export const FILES_LIMIT = 20;

export const MAX_FILE_SIZE = 20971520;

export const FILE_MIME_TYPES = `video/mp4,audio/mp4,application/mp4,video/webm,video/quicktime`;
